import axios from "axios";
import { axiosApiInstance } from "../App";
import { url } from "./url.service";

const serverUrl = url + "/shipping";

export const addShippings = (formData) => {
    return axiosApiInstance.post(serverUrl + "/", formData);
};

export const getShippings = (query) => {
    return axiosApiInstance.get(`${serverUrl}?${query}`);
};

export const deleteShipping = (id) => {
    return axiosApiInstance.delete(`${serverUrl}/deleteById/${id}`);
};

export const updateShipping = (id, formData) => {
    return axiosApiInstance.patch(`${serverUrl}/updateById/${id}`, formData);
};

